import React from 'react';
import Button from '../../../../../../common/_custom/Button/Button';
import styles from './EditClassificationSaveBar.module.scss';

interface Props {
    stagedCount: number;
    saving: boolean;
    onCancel: () => void;
    onSave: () => void;
}

/** Sticky footer rendered while cashflow edit mode is active. */
function EditClassificationSaveBar({ stagedCount, saving, onCancel, onSave }: Props) {
    return (
        <div className={styles.SaveBar}>
            <span className={styles.Label}>
                Update Classification:
                {stagedCount > 0 && <span className={styles.Count}>{stagedCount} pending</span>}
            </span>
            <div className={styles.Actions}>
                <Button type="button" className={styles.CancelBtn} onClick={onCancel} disabled={saving} text="Cancel" />
                <Button
                    type="button"
                    className={styles.SaveBtn}
                    onClick={onSave}
                    disabled={saving || stagedCount === 0}
                    text={saving ? 'Saving…' : 'Save'}
                />
            </div>
        </div>
    );
}

export default EditClassificationSaveBar;
